import { Grid } from "@material-ui/core";
import { Create, CreateButton, Datagrid, DeleteWithConfirmButton, Edit, EditButton, Filter, List, required, SaveButton, SimpleForm, TextField, TextInput, Toolbar, TopToolbar, useNotify, useRecordContext } from "react-admin";

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const CustomDelete = () => {
  const record = useRecordContext();

  return (
    <DeleteWithConfirmButton //
      record={record}
      undoable={false}
      confirmContent="Are you sure you want to delete this item?"
      confirmTitle={`Delete ${record.name_en} ?`}
    />
  );
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const ListFilters = () => (
  <Filter>
    <TextInput label="Name in TC" source="name_tc" alwaysOn />
    <TextInput label="Name in EN" source="name_en" alwaysOn />
  </Filter>
);

export const ChannelCategoryList = (props) => (
  <List {...props} bulkActionButtons={false} pagination={false} actions={<ListActions />} filters={<ListFilters />}>
    <Datagrid>
      <TextField source="name_tc" label="Name in TC" sortable={false} />
      <TextField source="name_en" label="Name in EN" sortable={false} />
      <EditButton sortable={false} />
      <CustomDelete sortable={false} />
    </Datagrid>
  </List>
);

const ChannelCategoryCreateForm = () => {
  return (
    <Grid container spacing={1}>
      <Grid item sm={12} md={6}>
        <TextInput label="Name in TC" source="name_tc" validate={required()} fullWidth />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Name in EN" source="name_en" validate={required()} fullWidth />
      </Grid>
    </Grid>
  );
};

export const ChannelCategoryCreate = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <Create {...props} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm redirect="list">
        <ChannelCategoryCreateForm />
      </SimpleForm>
    </Create>
  );
};

export const ChannelCategoryEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <ChannelCategoryCreateForm />
      </SimpleForm>
    </Edit>
  );
};
